/*globals $*/
'use strict';

import validateInput from '../../../library/100x100/validation/validateInput';
import formFunctions from '../../../library/100x100/validation/formFunctions';

const formValidation = new validateInput("hundreds-validation__input_error", "hundreds-validation__input_success");
const formFuncs = new formFunctions("hundreds-validation__input_error", "hundreds-validation__input_success");

export const validateClientForm = () => {
    var url = $('#client-form').data('action');
    var go_url = $('#go-url').val();
    var formData = $('#client-form').serialize();

    var valid = true;

    var type = $('#type').find(':selected');

    var comercial_name = $('#comercial_name');
    var fiscal_reason = $('#fiscal_reason');
    var company_type = $('#company_type');
    var cif = $('#cif');
    var company_email = $('#company_email');
    var company_phone = $('#company_phone');

    var name = $('#name');
    var surname = $('#surname');

    var dni_nif = $('#dni_nif');
    var email = $('#email');
    var phone = $('#phone');
    var mobile = $('#mobile');

    var address = $('#address');
    var country = $('#country');
    var province = $('#province');
    var postal_code = $('#postal_code');


    if ($('input[name="type"]:checked').length <= 0) {
        valid = false;
        $('#type_error').removeClass('hidden');
    } else{
        $('#type_error').addClass('hidden');

        if($('input[name="type"]:checked').val() === 'person'){
            if (!formValidation.validateRequired(name)) { valid = false; $('#name_error').removeClass('hidden') } else{ $('#name_error').addClass('hidden')}
            if (!formValidation.validateRequired(surname)) { valid = false; $('#surname_error').removeClass('hidden') } else{ $('#surname_error').addClass('hidden')}
        }else{
            if(company_type.val() == ''){ valid = false; $('#company_type_error').removeClass('hidden'); $('#company_type').addClass('hundreds-validation__input_error') } else{ $('#company_type_error').addClass('hidden'); $('#company_type').removeClass('hundreds-validation__input_error')}
            if (!formValidation.validateRequired(comercial_name)) { valid = false; $('#comercial_name_error').removeClass('hidden') } else{ $('#comercial_name_error').addClass('hidden')}
            if (!formValidation.validateRequired(fiscal_reason)) { valid = false; $('#fiscal_reason_error').removeClass('hidden') } else{ $('#fiscal_reason_error').addClass('hidden')}
            if (!formValidation.validateIsDNI(cif)) { valid = false; $('#cif_error').removeClass('hidden') } else{ $('#cif_error').addClass('hidden')}
            if (!formValidation.validateIsEmail(company_email)) { valid = false; $('#company_email_error').removeClass('hidden') } else{ $('#company_email_error').addClass('hidden')}
            if (!formValidation.validateIsPhone(company_phone)) { valid = false; $('#company_phone_error').removeClass('hidden') } else{ $('#company_phone_error').addClass('hidden')}
        }
    }

    if (!formValidation.validateIsDNI(dni_nif)) { valid = false; $('#dni_nif_error').removeClass('hidden') } else{ $('#dni_nif_error').addClass('hidden')}
    if (!formValidation.validateIsEmail(email)) { valid = false; $('#email_error').removeClass('hidden') } else{ $('#email_error').addClass('hidden')}
    if (!formValidation.validateIsPhone(phone)) { valid = false; $('#phone_error').removeClass('hidden') } else{ $('#phone_error').addClass('hidden')}
    if (!formValidation.validateIsPhone(mobile)) { valid = false; $('#mobile_error').removeClass('hidden') } else{ $('#mobile_error').addClass('hidden')}

    if (!formValidation.validateRequired(address)) { valid = false; $('#address_error').removeClass('hidden') } else{ $('#address_error').addClass('hidden')}
    if (!formValidation.validateIsNumber(postal_code)) { valid = false; $('#postal_code_error').removeClass('hidden') } else{ $('#postal_code_error').addClass('hidden')}
    if(province.val() == ''){ valid = false; $('#province_error').removeClass('hidden'); $('#province').addClass('hundreds-validation__input_error') } else{ $('#province_error').addClass('hidden'); $('#province').removeClass('hundreds-validation__input_error')}
    if(country.val() == ''){ valid = false; $('#country_error').removeClass('hidden'); $('#country').addClass('hundreds-validation__input_error') } else{ $('#country_error').addClass('hidden'); $('#country').removeClass('hundreds-validation__input_error')}

    if (valid) {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax({
            type: "POST",
            url: url,
            data: formData,
            success: function(data) {
                data = JSON.parse(data);

                if(data && data['response'] == 'email_exists') {
                    $('#email').addClass('hundreds-validation__input_error');
                    $('#error_msg').text('El correu electronic ja pertany a un altre client');
                    $('#error_message').removeClass('message-hidden');
                    setTimeout(function () {
                        $('#error_message').addClass('message-hidden')
                    }, 60000);
                }else if(data && data['response'] == 'dni_exists'){
                    $('#email').addClass('hundreds-validation__input_error');
                        $('#error_msg').text('El DNI/NIF ja pertany a un altre client');
                        $('#error_message').removeClass('message-hidden');
                        setTimeout(function() {
                            $('#error_message').addClass('message-hidden')
                        }, 60000);
                }else {
                    if (data['response'] !== 'error') {
                        if(go_url == 'modal'){
                            $('#client_modal_form').modal('hide');

                            let newOption = new Option(name.val() + ' ' + surname.val(), data['response'], true, true);
                            $('#client').append(newOption).trigger('change');

                            $('#client_select').removeClass('hidden');
                        }else if (data['response'] !== 'success') {
                            window.location.href = go_url.slice(0, -1) + data['response'];
                        } else {
                            $('#success_message').removeClass('message-hidden');
                            setTimeout(function () {
                                $('#success_message').addClass('message-hidden')
                            }, 60000);
                        }
                    } else {

                        $('#error_message').removeClass('message-hidden');
                        setTimeout(function () {
                            $('#error_message').addClass('message-hidden')
                        }, 60000);
                    }
                }

            },
            error: function(xhr, status, error) {
                var err = eval("(" + xhr.responseText + ")");
                $('#error_message').removeClass('message-hidden');
                setTimeout(function() {
                    $('#error_message').addClass('message-hidden')
                }, 60000);
            }
        });

        return false;
    } else {
        return false;
    }
};

export const validateBrandForm = () => {
    var url = $('#brand-form').data('action');
    var go_url = $('#go-url').val();
    var formData = $('#brand-form').serialize();

    var valid = true;


    var name = $('#brand-name');

    if (!formValidation.validateRequired(name)) { valid = false; $('#brand-name_error').removeClass('hidden') } else{ $('#brand-name_error').addClass('hidden')}

    if (valid) {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax({
            type: "POST",
            url: url,
            data: formData,
            success: function(data) {
                data = JSON.parse(data);

                if (data['response'] != 'error') {
                    if (data['response'] !== 'success') {
                        if(go_url == 'modal'){
                            $('#brand_modal_form').modal('hide');
                            $('#brand').append($('<option>', {
                                value: data['response'],
                                text : name.val()
                            }));
                            $("#brand").val(data['response']).trigger("change");

                            $('#model-brand').append($('<option>', {
                                value: data['response'],
                                text : name.val()
                            }));
                            $("#model-brand").val(data['response']).trigger("change");

                            $("#brand-name").val('');
                        }else {
                            window.location.href = go_url.slice(0, -1) + data['response'];
                        }
                    } else {
                        $('#success_message').removeClass('message-hidden');
                        setTimeout(function () {
                            $('#success_message').addClass('message-hidden')
                        }, 60000);
                    }
                } else {

                    $('#error_message').removeClass('message-hidden');
                    setTimeout(function () {
                        $('#error_message').addClass('message-hidden')
                    }, 60000);
                }


            },
            error: function(xhr, status, error) {
                var err = eval("(" + xhr.responseText + ")");
                $('#error_message').removeClass('message-hidden');
                setTimeout(function() {
                    $('#error_message').addClass('message-hidden')
                }, 60000);
            }
        });

        return false;
    } else {
        return false;
    }
};

export const validateModelForm = () => {
    var url = $('#model-form').data('action');
    var go_url = $('#go-url').val();
    var formData = $('#model-form').serialize();

    var valid = true;

    var name = $('#model-name');
    var brand = $('[name^="model-brand"]');

    if (!formValidation.validateRequired(name)) { valid = false; $('#model-name_error').removeClass('hidden') } else{ $('#model-name_error').addClass('hidden')}
    if(brand.val() == ''){ valid = false; $('#model-brand_error').removeClass('hidden'); $('#model-brand').addClass('hundreds-validation__input_error') } else{ $('#model-brand_error').addClass('hidden'); $('#model-brand').removeClass('hundreds-validation__input_error')}

    if (valid) {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax({
            type: "POST",
            url: url,
            data: formData,
            success: function(data) {
                data = JSON.parse(data);

                if (data['response'] != 'error') {
                    if (data['response'] !== 'success') {
                        if(go_url == 'modal'){
                            $('#model_modal_form').modal('hide');
                            $('#model').append($('<option>', {
                                value: data['response'],
                                text : name.val()
                            }));
                            $("#model").val(data['response']).trigger("change");

                            $("#model-name").val('');
                        }else {
                            window.location.href = go_url.slice(0, -1) + data['response'];
                        }
                    } else {
                        $('#success_message').removeClass('message-hidden');
                        setTimeout(function () {
                            $('#success_message').addClass('message-hidden')
                        }, 60000);
                    }
                } else {

                    $('#error_message').removeClass('message-hidden');
                    setTimeout(function () {
                        $('#error_message').addClass('message-hidden')
                    }, 60000);
                }


            },
            error: function(xhr, status, error) {
                var err = eval("(" + xhr.responseText + ")");
                $('#error_message').removeClass('message-hidden');
                setTimeout(function() {
                    $('#error_message').addClass('message-hidden')
                }, 60000);
            }
        });

        return false;
    } else {
        return false;
    }
};

export const validateCategoryForm = () => {
    var url = $('#category-form').data('action');
    var go_url = $('#go-url').val();
    var formData = $('#category-form').serialize();

    var valid = true;

    var name = $('#name');

    if (!formValidation.validateRequired(name)) { valid = false; $('#name_error').removeClass('hidden') } else{ $('#name_error').addClass('hidden')}

    if (valid) {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax({
            type: "POST",
            url: url,
            data: formData,
            success: function(data) {
                data = JSON.parse(data);

                if (data['response'] != 'error') {
                    if (data['response'] !== 'success') {
                        window.location.href = go_url.slice(0, -1) + data['response'];
                    } else {
                        $('#success_message').removeClass('message-hidden');
                        setTimeout(function () {
                            $('#success_message').addClass('message-hidden')
                        }, 60000);
                    }
                } else {

                    $('#error_message').removeClass('message-hidden');
                    setTimeout(function () {
                        $('#error_message').addClass('message-hidden')
                    }, 60000);
                }


            },
            error: function(xhr, status, error) {
                var err = eval("(" + xhr.responseText + ")");
                $('#error_message').removeClass('message-hidden');
                setTimeout(function() {
                    $('#error_message').addClass('message-hidden')
                }, 60000);
            }
        });

        return false;
    } else {
        return false;
    }
};

export const validateAccessoryForm = () => {
    var url = $('#accessory-form').data('action');
    var go_url = $('#go-url').val();
    var formData = $('#accessory-form').serialize();

    var valid = true;

    var name = $('#name');
    var price = $('#price');

    if (!formValidation.validateRequired(name)) { valid = false; $('#name_error').removeClass('hidden') } else{ $('#name_error').addClass('hidden')}
    if (!formValidation.validateRequired(price)) { valid = false; $('#price_error').removeClass('hidden') } else{ $('#price_error').addClass('hidden')}

    if (valid) {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax({
            type: "POST",
            url: url,
            data: formData,
            success: function(data) {
                data = JSON.parse(data);

                if (data['response'] != 'error') {
                    if (data['response'] !== 'success') {
                            window.location.href = go_url.slice(0, -1) + data['response'];
                    } else {
                        $('#success_message').removeClass('message-hidden');
                        setTimeout(function () {
                            $('#success_message').addClass('message-hidden')
                        }, 60000);
                    }
                } else {

                    $('#error_message').removeClass('message-hidden');
                    setTimeout(function () {
                        $('#error_message').addClass('message-hidden')
                    }, 60000);
                }


            },
            error: function(xhr, status, error) {
                var err = eval("(" + xhr.responseText + ")");
                $('#error_message').removeClass('message-hidden');
                setTimeout(function() {
                    $('#error_message').addClass('message-hidden')
                }, 60000);
            }
        });

        return false;
    } else {
        return false;
    }
};

export const validateAutomaticPedalForm = () => {
    var url = $('#automatic_pedal-form').data('action');
    var go_url = $('#go-url').val();
    var formData = $('#automatic_pedal-form').serialize();

    var valid = true;

    var name = $('#name');

    if (!formValidation.validateRequired(name)) { valid = false; $('#name_error').removeClass('hidden') } else{ $('#name_error').addClass('hidden')}

    if (valid) {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax({
            type: "POST",
            url: url,
            data: formData,
            success: function(data) {
                data = JSON.parse(data);

                if (data['response'] != 'error') {
                    if (data['response'] !== 'success') {
                        window.location.href = go_url.slice(0, -1) + data['response'];
                    } else {
                        $('#success_message').removeClass('message-hidden');
                        setTimeout(function () {
                            $('#success_message').addClass('message-hidden')
                        }, 60000);
                    }
                } else {

                    $('#error_message').removeClass('message-hidden');
                    setTimeout(function () {
                        $('#error_message').addClass('message-hidden')
                    }, 60000);
                }


            },
            error: function(xhr, status, error) {
                var err = eval("(" + xhr.responseText + ")");
                $('#error_message').removeClass('message-hidden');
                setTimeout(function() {
                    $('#error_message').addClass('message-hidden')
                }, 60000);
            }
        });

        return false;
    } else {
        return false;
    }
};

export const validateBrakeForm = () => {
    var url = $('#brake-form').data('action');
    var go_url = $('#go-url').val();
    var formData = $('#brake-form').serialize();

    var valid = true;

    var name = $('#name');

    if (!formValidation.validateRequired(name)) { valid = false; $('#name_error').removeClass('hidden') } else{ $('#name_error').addClass('hidden')}

    if (valid) {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax({
            type: "POST",
            url: url,
            data: formData,
            success: function(data) {
                data = JSON.parse(data);

                if (data['response'] != 'error') {
                    if (data['response'] !== 'success') {
                        window.location.href = go_url.slice(0, -1) + data['response'];
                    } else {
                        $('#success_message').removeClass('message-hidden');
                        setTimeout(function () {
                            $('#success_message').addClass('message-hidden')
                        }, 60000);
                    }
                } else {

                    $('#error_message').removeClass('message-hidden');
                    setTimeout(function () {
                        $('#error_message').addClass('message-hidden')
                    }, 60000);
                }


            },
            error: function(xhr, status, error) {
                var err = eval("(" + xhr.responseText + ")");
                $('#error_message').removeClass('message-hidden');
                setTimeout(function() {
                    $('#error_message').addClass('message-hidden')
                }, 60000);
            }
        });

        return false;
    } else {
        return false;
    }
};

export const validateFrameSizeForm = () => {
    var url = $('#frame_size-form').data('action');
    var go_url = $('#go-url').val();
    var formData = $('#frame_size-form').serialize();

    var valid = true;

    var name = $('#name');

    if (!formValidation.validateRequired(name)) { valid = false; $('#name_error').removeClass('hidden') } else{ $('#name_error').addClass('hidden')}

    if (valid) {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax({
            type: "POST",
            url: url,
            data: formData,
            success: function(data) {
                data = JSON.parse(data);

                if (data['response'] != 'error') {
                    if (data['response'] !== 'success') {
                        window.location.href = go_url.slice(0, -1) + data['response'];
                    } else {
                        $('#success_message').removeClass('message-hidden');
                        setTimeout(function () {
                            $('#success_message').addClass('message-hidden')
                        }, 60000);
                    }
                } else {

                    $('#error_message').removeClass('message-hidden');
                    setTimeout(function () {
                        $('#error_message').addClass('message-hidden')
                    }, 60000);
                }


            },
            error: function(xhr, status, error) {
                var err = eval("(" + xhr.responseText + ")");
                $('#error_message').removeClass('message-hidden');
                setTimeout(function() {
                    $('#error_message').addClass('message-hidden')
                }, 60000);
            }
        });

        return false;
    } else {
        return false;
    }
};

export const validateMarchForm = () => {
    var url = $('#march-form').data('action');
    var go_url = $('#go-url').val();
    var formData = $('#march-form').serialize();

    var valid = true;

    var name = $('#name');

    if (!formValidation.validateRequired(name)) { valid = false; $('#name_error').removeClass('hidden') } else{ $('#name_error').addClass('hidden')}

    if (valid) {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax({
            type: "POST",
            url: url,
            data: formData,
            success: function(data) {
                data = JSON.parse(data);

                if (data['response'] != 'error') {
                    if (data['response'] !== 'success') {
                        window.location.href = go_url.slice(0, -1) + data['response'];
                    } else {
                        $('#success_message').removeClass('message-hidden');
                        setTimeout(function () {
                            $('#success_message').addClass('message-hidden')
                        }, 60000);
                    }
                } else {

                    $('#error_message').removeClass('message-hidden');
                    setTimeout(function () {
                        $('#error_message').addClass('message-hidden')
                    }, 60000);
                }


            },
            error: function(xhr, status, error) {
                var err = eval("(" + xhr.responseText + ")");
                $('#error_message').removeClass('message-hidden');
                setTimeout(function() {
                    $('#error_message').addClass('message-hidden')
                }, 60000);
            }
        });

        return false;
    } else {
        return false;
    }
};

export const validateWheelSizeForm = () => {
    var url = $('#wheel_size-form').data('action');
    var go_url = $('#go-url').val();
    var formData = $('#wheel_size-form').serialize();

    var valid = true;

    var name = $('#name');

    if (!formValidation.validateRequired(name)) { valid = false; $('#name_error').removeClass('hidden') } else{ $('#name_error').addClass('hidden')}

    if (valid) {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax({
            type: "POST",
            url: url,
            data: formData,
            success: function(data) {
                data = JSON.parse(data);

                if (data['response'] != 'error') {
                    if (data['response'] !== 'success') {
                        window.location.href = go_url.slice(0, -1) + data['response'];
                    } else {
                        $('#success_message').removeClass('message-hidden');
                        setTimeout(function () {
                            $('#success_message').addClass('message-hidden')
                        }, 60000);
                    }
                } else {

                    $('#error_message').removeClass('message-hidden');
                    setTimeout(function () {
                        $('#error_message').addClass('message-hidden')
                    }, 60000);
                }


            },
            error: function(xhr, status, error) {
                var err = eval("(" + xhr.responseText + ")");
                $('#error_message').removeClass('message-hidden');
                setTimeout(function() {
                    $('#error_message').addClass('message-hidden')
                }, 60000);
            }
        });

        return false;
    } else {
        return false;
    }
};

export const validateBikeForm = () => {
    var url = $('#bike-form').data('action');
    var go_url = $('#go-url-bike').val();
    var formData = $('#bike-form').serialize();


    var valid = true;

    var code = $('#code');

    var brand = $('#brand');
    var model = $('#model');
    var chassis = $('#chassis');
    var color = $('#color');
    var type = $('#type');

    var purchase_year = $('#purchase_year');
    var price = $('#price');
    var wheel_size = $('#wheel_size');
    var brakes = $('#brakes');
    var marches = $('#marches');
    var frame_size = $('#frame_size');
    var pedals = $('#pedals');
    var automatic_pedals = $('#automatic_pedals');

    if (!formValidation.validateRequired(code)) { valid = false; $('#code_error').removeClass('hidden') } else{ $('#code_error').addClass('hidden')}
    if(brand.val() == ''){ valid = false; $('#brand_error').removeClass('hidden'); $('#brand').addClass('hundreds-validation__input_error') } else{ $('#brand_error').addClass('hidden'); $('#brand').removeClass('hundreds-validation__input_error')}
    if(model.val() == ''){ valid = false; $('#model_error').removeClass('hidden'); $('#model').addClass('hundreds-validation__input_error') } else{ $('#model_error').addClass('hidden'); $('#model').removeClass('hundreds-validation__input_error')}
    if (!formValidation.validateRequired(chassis)) { valid = false; $('#chassis_error').removeClass('hidden') } else{ $('#chassis_error').addClass('hidden')}
    if ($('input[name="status"]:checked').length <= 0) {valid = false;$('#status_error').removeClass('hidden');} else{$('#status_error').addClass('hidden');}

    if ($('input[name="gender"]:checked').length <= 0) {valid = false;$('#gender_error').removeClass('hidden');} else{$('#gender_error').addClass('hidden');}
    if(type.val() == ''){ valid = false; $('#type_error').removeClass('hidden'); $('#type').addClass('hundreds-validation__input_error') } else{ $('#type_error').addClass('hidden'); $('#type').removeClass('hundreds-validation__input_error')}
    // if(color.val() == ''){ valid = false; $('#color_error').removeClass('hidden'); $('#color').addClass('hundreds-validation__input_error') } else{ $('#color_error').addClass('hidden'); $('#color').removeClass('hundreds-validation__input_error')}
    if(wheel_size.val() == ''){ valid = false; $('#wheel_size_error').removeClass('hidden'); $('#wheel_size').addClass('hundreds-validation__input_error') } else{ $('#wheel_size_error').addClass('hidden'); $('#wheel_size').removeClass('hundreds-validation__input_error')}
    if(brakes.val() == ''){ valid = false; $('#brakes_error').removeClass('hidden'); $('#brakes').addClass('hundreds-validation__input_error') } else{ $('#brakes_error').addClass('hidden'); $('#brakes').removeClass('hundreds-validation__input_error')}
    if(marches.val() == ''){ valid = false; $('#marches_error').removeClass('hidden'); $('#marches').addClass('hundreds-validation__input_error') } else{ $('#marches_error').addClass('hidden'); $('#marches').removeClass('hundreds-validation__input_error')}
    if(frame_size.val() == ''){ valid = false; $('#frame_size_error').removeClass('hidden'); $('#frame_size').addClass('hundreds-validation__input_error') } else{ $('#frame_size_error').addClass('hidden'); $('#frame_size').removeClass('hundreds-validation__input_error')}
    if(pedals.val() == ''){ valid = false; $('#pedals_error').removeClass('hidden'); $('#pedals').addClass('hundreds-validation__input_error') } else{ $('#pedals_error').addClass('hidden'); $('#pedals').removeClass('hundreds-validation__input_error')}

    if (!formValidation.validateRequired(purchase_year)) { valid = false; $('#purchase_year_error').removeClass('hidden') } else{ $('#purchase_year_error').addClass('hidden')}
    if(pedals.val() == 'automatic') {
        if (automatic_pedals.val() == '') {
            valid = false;
            $('#automatic_pedals_error').removeClass('hidden');
            $('#automatic_pedals').addClass('hundreds-validation__input_error')
        } else {
            $('#automatic_pedals_error').addClass('hidden');
            $('#automatic_pedals').removeClass('hundreds-validation__input_error')
        }
    }


    if (valid) {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax({
            type: "POST",
            url: url,
            data: formData,
            success: function(data) {
                data = JSON.parse(data);

                if (data['response'] != 'error' && data['response'] != 'exists') {
                    if (data['response'] !== 'success') {
                        window.location.href = go_url.slice(0, -1) + data['response'];
                    } else {
                        $('#success_message').removeClass('message-hidden');
                        setTimeout(function () {
                            $('#success_message').addClass('message-hidden')
                        }, 60000);
                    }
                } else {
                    if (data['response'] == 'exists') {
                        $('#error_msg').text('El codi ja pertany a una altra bicicleta');
                    }

                    $('#error_message').removeClass('message-hidden');
                    setTimeout(function () {
                        $('#error_message').addClass('message-hidden')
                    }, 60000);

                }

            },
            error: function(xhr, status, error) {
                var err = eval("(" + xhr.responseText + ")");
                $('#error_message').removeClass('message-hidden');
                setTimeout(function() {
                    $('#error_message').addClass('message-hidden')
                }, 60000);
            }
        });

        return false;
    } else {
        return false;
    }
};

export const validateClientStepBookingForm = () => {
    // var init_date = $('#init_date');
    // var end_date = $('#end_date');
    // var table = $('#list_book').DataTable();
    var client = $('#client');

    var valid = true;


    // if(init_date.val() == ''){ valid = false; $('#init_date').addClass('hundreds-validation__input_error') } else{  $('#init_date').removeClass('hundreds-validation__input_error')}
    // if(end_date.val() == ''){ valid = false; $('#end_date').addClass('hundreds-validation__input_error') } else{  $('#end_date').removeClass('hundreds-validation__input_error')}
    if(client.val() == ''){valid = false; $('#client_error').removeClass('hidden'); } else{  $('#client_error').addClass('hidden');}

    // if(table.rows().count() <= 0) {valid = false;  $('#booking_error').removeClass('hidden') } else{  $('#booking_error').addClass('hidden')}

    if(valid){
        $('#step_one').addClass('hidden');
        $('#checkClientStepBooking').addClass('hidden')

        $('#step_two').removeClass('hidden');
        $('#client_info').removeClass('hidden');
        $('#checkDatesStepBooking').removeClass('hidden');
    } else{
        $('html, body').animate({ scrollTop: 0 }, 'slow');
    }
}

export const validateBikesStepBookingForm = () => {
    var table = $('#list_book').DataTable();
    // var delivery_custom = $('#delivery_custom');
    // var pickup_custom = $('#pickup_custom');

    var valid = true;

    if(table.rows().count() <= 0) {valid = false;  $('#booking_error').removeClass('hidden') } else{  $('#booking_error').addClass('hidden')}
    // if ($('input[name="delivery"]:checked').length <= 0) {valid = false; $('#delivery_error').removeClass('hidden')} else {$('#delivery_error').addClass('hidden');}
    // if ($('input[name="pickup"]:checked').length <= 0) {valid = false; $('#pickup_error').removeClass('hidden')} else {$('#pickup_error').addClass('hidden');}

    if(valid){
        $('#mini-step_two').addClass('hidden');
        $('#checkBikesStepBooking').addClass('hidden')
        $('#backToDatesStepBooking').addClass('hidden')

        $('#mini-step_three').removeClass('hidden');
        $('#circle_mini-step_three').addClass('active');
        $('#checkDeliveryStepBooking').removeClass('hidden');
        $('#backToBikesStepBooking').removeClass('hidden');

    } else{
        // $('html, body').animate({ scrollTop: 0 }, 'slow');
    }
}

export const validateDeliveryStepBookingForm = () => {

    var valid = true;

    var delivery = $('#delivery').find(':selected');
    var delivery_address = $('#delivery_address');
    var delivery_country = $('#delivery_country');
    var delivery_province = $('#delivery_province');
    var delivery_postal_code = $('#delivery_postal_code');
    var delivery_time_slot = $('#delivery_time_slot');

    var pickup = $('#pickup').find(':selected');
    var pickup_address = $('#pickup_address');
    var pickup_country = $('#pickup_country');
    var pickup_province = $('#pickup_province');
    var pickup_postal_code = $('#pickup_postal_code');
    var pickup_time_slot = $('#pickup_time_slot');


    if($('input[name="delivery"]:checked').val() === 'home'){
        if(delivery_time_slot.val() == ''){ valid = false; $('#delivery_time_slot_error').removeClass('hidden'); $('#delivery_time_slot').addClass('hundreds-validation__input_error') } else{ $('#delivery_time_slot_error').addClass('hidden'); $('#delivery_time_slot').removeClass('hundreds-validation__input_error')}
        if (!formValidation.validateRequired(delivery_address)) { valid = false; $('#delivery_address_error').removeClass('hidden') } else{ $('#delivery_address_error').addClass('hidden')}
        if (!formValidation.validateIsNumber(delivery_postal_code)) { valid = false; $('#delivery_postal_code_error').removeClass('hidden') } else{ $('#delivery_postal_code_error').addClass('hidden')}
        if(delivery_province.val() == ''){ valid = false; $('#delivery_province_error').removeClass('hidden'); $('#delivery_province').addClass('hundreds-validation__input_error') } else{ $('#delivery_province_error').addClass('hidden'); $('#delivery_province').removeClass('hundreds-validation__input_error')}
        if(delivery_country.val() == ''){ valid = false; $('#delivery_country_error').removeClass('hidden'); $('#delivery_country').addClass('hundreds-validation__input_error') } else{ $('#delivery_country_error').addClass('hidden'); $('#delivery_country').removeClass('hundreds-validation__input_error')}
    }

    if($('input[name="pickup"]:checked').val() === 'home'){
        if(pickup_time_slot.val() == ''){ valid = false; $('#pickup_time_slot_error').removeClass('hidden'); $('#pickup_time_slot').addClass('hundreds-validation__input_error') } else{ $('#pickup_time_slot_error').addClass('hidden'); $('#pickup_time_slot').removeClass('hundreds-validation__input_error')}
        if (!$('#same_address').is(':checked')){
            if (!formValidation.validateRequired(pickup_address)) { valid = false; $('#pickup_address_error').removeClass('hidden') } else{ $('#pickup_address_error').addClass('hidden')}
            if (!formValidation.validateIsNumber(pickup_postal_code)) { valid = false; $('#pickup_postal_code_error').removeClass('hidden') } else{ $('#pickup_postal_code_error').addClass('hidden')}
            if(pickup_province.val() == ''){ valid = false; $('#pickup_province_error').removeClass('hidden'); $('#pickup_province').addClass('hundreds-validation__input_error') } else{ $('#pickup_province_error').addClass('hidden'); $('#delivery_province').removeClass('hundreds-validation__input_error')}
            if(pickup_country.val() == ''){ valid = false; $('#pickup_country_error').removeClass('hidden'); $('#pickup_country').addClass('hundreds-validation__input_error') } else{ $('#pickup_country_error').addClass('hidden'); $('#delivery_country').removeClass('hundreds-validation__input_error')}
        }else{
            valid = true;
        }
    }

    if(valid){
        $('#mini-step_three').addClass('hidden');
        $('#checkDeliveryStepBooking').addClass('hidden')
        $('#backToBikesStepBooking').addClass('hidden');
        $('#circle_mini-step_four').addClass('active');

        $('#mini-step_four').removeClass('hidden');
        $('#checkConfirmBooking').removeClass('hidden');
        $('#backToDeliveryStepBooking').removeClass('hidden');

        $('#details_delivery_type').text($("input[name='delivery']:checked").next("label").text());
        if($('input[name="delivery"]:checked').val() === 'home') {
            $('#mini-info-address').removeClass('hidden');
            $('#details_delivery_time').text($("#delivery_time_slot option:selected").text());
            $('#details_delivery_address').text(delivery_address.val() + ', ' + $('#delivery_city').val() + ', ' + delivery_postal_code.val() + ' ' +  $("#delivery_province option:selected").text());
        }else {
            $('#mini-info-address').addClass('hidden');
            $('#details_delivery_time').text('');
            $('#details_delivery_address').text('');
        }


        $('#details_pickup_type').text($("input[name='pickup']:checked").next("label").text());
        if($('input[name="pickup"]:checked').val() === 'home') {
            $('#mini-info-address').removeClass('hidden');

            if ($('#same_address').is(':checked')) {
                $('#details_pickup_time').text($("#delivery_time_slot option:selected").text());
                $('#details_pickup_address').text(delivery_address.val() + ', ' + $('#delivery_city').val() + ', ' + delivery_postal_code.val() + ' ' + $("#delivery_province option:selected").text());
            }else {
                $('#details_pickup_time').text($("#pickup_time_slot option:selected").text());
                $('#details_pickup_address').text(pickup_address.val() + ', ' + $('#pickup_city').val() + ', ' + pickup_postal_code.val() + ' ' +  $("#pickup_province option:selected").text());
            }
        }else {
            $('#mini-info-address').addClass('hidden');
            $('#details_pickup_time').text('');
            $('#details_pickup_address').text('');
        }

    } else{
        $('html, body').animate({ scrollTop: 0 }, 'slow');
    }

}

export const validateConfirmBookingForm = () => {

    var valid = true;

    var hasRadio = $('input[name="payment_method"]:checked').length > 0;
    var hasHidden = $('input[name="payment_method"][type="hidden"]').length > 0;

    if (!hasRadio && !hasHidden) {
        valid = false;
        $('#payment_method_error').removeClass('hidden');
    } else {
        $('#payment_method_error').addClass('hidden');
    }

    if(valid){
        $('#booking-form').submit();
    }
}

export const validateNewPriceForm = () => {
    var url = $('#new-price-form').data('action');
    var formData = $('#new-price-form').serialize();


    var valid = true;
    let unique = true


    if ($("input[name='type[]']:checked").length <= 0) {
        valid = false;
        $("#type_error").removeClass('hidden')
    }else{
        $("#type_error").addClass('hidden')

    }

    let selectedTypes = [];
    let existingTypes = [];
    let duplicateTypes = '';

    if ($("input[name^='price_'][name$='_type[]']").length !== 0) {

        $("input[name='type[]']:checked").each(function () {
            selectedTypes.push($(this).val());
        });

        $("input[name^='price_'][name$='_type[]']:checked").each(function () {
            existingTypes.push($(this).val());
        });

        duplicateTypes = selectedTypes.some(value => existingTypes.includes(value));

        if (duplicateTypes) {
            unique = false;
        }
    }

    if(!unique){
        $('#error_modal_msg').text('Les categories nomes poden tenir una taula de preus associada');
        $('#error_modal_message').removeClass('message-hidden');
        setTimeout(function () {
            $('#error_modal_message').addClass('message-hidden')
        }, 60000);
    }

    $("input[id^='new_price_']").each(function () {
        let input = $(this);

        if ($.trim(input.val()) === "") {
            valid = false;
            $(this).addClass('hundreds-validation__input_error');
        } else {
            $(this).removeClass('hundreds-validation__input_error');
        }
    });

    if (valid && unique) {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax({
            type: "POST",
            url: url,
            data: formData,
            success: function(data) {
                data = JSON.parse(data);

                if (data['response'] == 'success') {
                    location.reload();
                } else {
                    $('#error_message').removeClass('message-hidden');
                    setTimeout(function () {
                        $('#error_message').addClass('message-hidden')
                    }, 60000);
                }
            },
            error: function(xhr, status, error) {
                var err = eval("(" + xhr.responseText + ")");
                $('#error_message').removeClass('message-hidden');
                setTimeout(function() {
                    $('#error_message').addClass('message-hidden')
                }, 60000);
            }
        });

        return false;
    } else {
        return false;
    }
}

export const validatePricesForm = () => {
    let url = $('#update-price-form').data('action');
    let formData = $('#update-price-form').serialize();

    let valid = true;

    let unique = true;
    let selectedTypes = {};

    $("[id^='price_'][id$='_error']").each(function () {
        let id = $(this).attr("id").replace("_error", "");
        let checkboxes = $("input[name='" + id + "_type[]']:checked");

        if (checkboxes.length === 0) {
            $("#" + id + "_error").removeClass("hidden");
            valid = false;
        }
    });

    $("input[id^='price_']").each(function () {
        let input = $(this);

        if ($.trim(input.val()) === "") {
            valid = false;
            $(this).addClass('hundreds-validation__input_error');
        } else {
            $(this).removeClass('hundreds-validation__input_error');

        }
    });

    $("input[type='checkbox'][id^='price_'][id*='_type_']").each(function () {
        let checkbox = $(this);
        let idParts = checkbox.attr("id").split("_");
        let priceId = idParts[1];
        let typeValue = checkbox.val();

        if (!selectedTypes[priceId]) {
            selectedTypes[priceId] = new Set();
        }

        if (checkbox.is(":checked")) {
            if (Object.values(selectedTypes).some(set => set.has(typeValue) && set !== selectedTypes[priceId])) {
                unique = false;
                checkbox.addClass('hundreds-validation__input_error');
            } else {
                selectedTypes[priceId].add(typeValue);
                checkbox.removeClass('hundreds-validation__input_error');
            }
        }
    });

    if(!unique){
        $('#error_msg').text('Les categories nomes poden tenir una taula de preus associada');
        $('#error_message').removeClass('message-hidden');
        setTimeout(function () {
            $('#error_message').addClass('message-hidden')
        }, 60000);
    }

    if (valid && unique) {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax({
            type: "POST",
            url: url,
            data: formData,
            success: function(data) {
                data = JSON.parse(data);

                if (data['response'] == 'success') {
                    $('#success_message').removeClass('message-hidden');
                    setTimeout(function () {
                        $('#success_message').addClass('message-hidden')
                    }, 60000);
                } else {
                    $('#error_message').removeClass('message-hidden');
                    setTimeout(function () {
                        $('#error_message').addClass('message-hidden')
                    }, 60000);
                }
            },
            error: function(xhr, status, error) {
                var err = eval("(" + xhr.responseText + ")");
                $('#error_message').removeClass('message-hidden');
                setTimeout(function() {
                    $('#error_message').addClass('message-hidden')
                }, 60000);
            }
        });

        return false;
    } else {
        return false;
    }
}

export const validateCalendarForm = () => {

    var valid = true;

    if ($('#date').val() == '') {valid = false; $('#date').addClass('hundreds-validation__input_error')} else {$('#date').removeClass('hundreds-validation__input_error');}

    if(valid){
        $('#calendar-form').submit();
    } else{
        $('html, body').animate({ scrollTop: 0 }, 'slow');
    }
}
